export { Paragraph } from "./Paragraph"
export type { ParagraphProps } from "./Paragraph"
